import React from 'react';
import './MScInAccountingAndFinance.css'; // Optional: Create a CSS file for styling

const BScAccountingFinance = () => {
  return (
    <div className="msc-container" style={{ padding: '20px', maxWidth: '800px',  marginTop: '160px',marginLeft:'70px' }}>
      <h1 style={{ textAlign: 'center' }}>📘 Bachelor of Science in Accounting and Finance</h1>

      <section>
        <h2 style={{ textAlign: 'center' }}>Program Overview</h2>
        <p>
          The BSc in Accounting and Finance at Admas University prepares students to become skilled professionals in financial management, reporting, auditing, taxation, and investment analysis. The program emphasizes practical knowledge, ethical practices, and analytical thinking essential for today’s dynamic business environment.
        </p>
      </section>

      <section>
        <h2>🎓 Program Objectives</h2>
        <ul>
          <li>To provide a solid foundation in accounting principles and financial management.</li>
          <li>To equip students with practical tools for analyzing and interpreting financial data.</li>
          <li>To develop ethical and responsible finance professionals for public and private sectors.</li>
          <li>To foster critical thinking, research, and communication skills in financial decision-making.</li>
        </ul>
      </section>

      <section>
        <h2>📚 Core Courses</h2>
        <ul>
          <li>Financial Accounting</li>
          <li>Management Accounting</li>
          <li>Corporate Finance</li>
          <li>Business Law and Ethics</li>
          <li>Taxation</li>
          <li>Auditing</li>
          <li>Public Sector Accounting</li>
          <li>Investment and Portfolio Management</li>
        </ul>
      </section>

      <section>
        <h2>🎓 Admission Requirements</h2>
        <ul>
          <li>Successful completion of the Ethiopian Higher Education Entrance Certificate (Grade 12 national exam).</li>
          <li>Transfer students from other recognized universities or colleges may also be accepted.</li>
          <li>TVET graduates (Level IV) with COC certification may join through a bridging program.</li>
        </ul>
      </section>

      <section>
        <h2>🧭 Career Opportunities</h2>
        <p>
          Graduates can pursue careers as accountants, financial analysts, auditors, tax consultants, budget officers, and finance managers. They are well-suited for roles in private businesses, banks, NGOs, public institutions, and international organizations.
        </p>
      </section>

      <section>
        <h2>🏛️ Why Choose Admas University?</h2>
        <ul>
          <li>Industry-aligned curriculum with local and international relevance.</li>
          <li>Access to experienced faculty and practical training opportunities.</li>
          <li>Flexible learning modes including regular, evening, and weekend sessions.</li>
          <li>Nationwide campus network and strong alumni support.</li>
          <li>Accredited by the Ministry of Education and respected in the labor market.</li>
        </ul>
      </section>
    </div>
  );
};

export default BScAccountingFinance;